// src/components/HeroSlider.tsx

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade } from "swiper/modules";

import "swiper/css";
import "swiper/css/effect-fade";

const slides = [
  {
    image: "/assets/images/tour-management.jpg",
    title: "Smart Tour & Travel Solutions",
    subtitle: "Transforming Travel Businesses Digitally",
    desc: "Empowering tour operators and travel agencies with modern booking systems, CRM solutions, travel portals, and seamless customer experiences.",
  },
  {
    image: "/assets/images/software-development.jpg",
    title: "Custom Software Development Solutions",
    subtitle: "Building scalable, secure, and innovative digital products for modern businesses",
  },
  {
    image: "/assets/images/sl01.jpg",
    title: "Innovative IT Solutions",
    subtitle: "Empowering your business with technology",
  },
  {
    image: "/assets/images/sl02.jpg",
    title: "Web & Mobile Development",
    subtitle: "Scalable and high-performance apps",
  },
  {
    image: "/assets/images/sl03.jpg",
    title: "Digital Transformation",
    subtitle: "Driving growth through innovation",
  },
];

const AnimatedSlider = () => {
  return (
    <section className="animated-slider">
      <Swiper
        modules={[Autoplay, EffectFade]}
        effect="fade"
        loop
        autoplay={{ delay: 2000, disableOnInteraction: false }}
        speed={1200}
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <div
              className="slide"
              style={{ backgroundImage: `url(${slide.image})` }}
            >
              <div className="overlay" />

              <div className="content">
                <h1>{slide.title}</h1>
                <h5>{slide.subtitle}</h5>
                {/* <p>{slide.desc}</p> */}
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default AnimatedSlider;